import type { ReactNode } from "react";

import type { BoardModelKind } from "@/lib/timeline/board";

interface BoardModelDebugProps {
  kind: BoardModelKind;
  id: string;
  debug: boolean;
  children: ReactNode;
}

export function BoardModelDebug({
  kind,
  id,
  debug,
  children,
}: BoardModelDebugProps) {
  if (!debug) {
    return children;
  }
  return (
    <div
      className="board-model-debug board-model-debug--active"
      data-board-model={kind}
      data-board-id={id}
    >
      {children}
    </div>
  );
}
